import { useContext, useMemo } from 'react'
import { MobXProviderContext } from 'mobx-react'

import { AppRootStore } from '../stores/appRoot.store'

export const getAppStore = () => new AppRootStore()

let appRootStore

function initializeStore() {
  const shouldCreateStores = typeof appRootStore === 'undefined'

  if (shouldCreateStores) {
    appRootStore = getAppStore()
  }

  return appRootStore
}

export function useAppStore() {
  return useMemo(() => initializeStore(), [])
}

export const useAppStores = () => useContext(MobXProviderContext) as AppRootStore
